const spacingUnit = 8;
const multipliers = <const>[.5, 1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10, 12];

export type multiplierType = { [key in typeof multipliers[number]]: string }

export const spacing = multipliers.reduce((acc, cur) => ({ 
  ...acc, 
  [cur]: `${cur * spacingUnit}px` 
}), {} as multiplierType);

